import { camelCase } from 'lodash';
// GET_USER => getUser
export const actionTypeToCamelCase = (actionType) => camelCase(actionType);
export default actionTypeToCamelCase;
